module.exports = __webpack_public_path__ + "img/title-ac.6a6c16dd.png";